import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Navbar from "./Pages/Shared/Navbar";
import PastIUPCPage from "./Pages/IUPC/PastContest";
import UpcomingIUPCPage from "./Pages/IUPC/UpcomingContest";
import HallOfShame from "./Pages/Home/HallOfShame";
import MentorsPage from "./Pages/Home/Mentors";
import Footer from "./Pages/Home/Footer";
import TermsAndConditions from "./Pages/Shared/TermsAndConditions";
import CommitteePage from "./Pages/Home/Committee";
import EventsPage from "./Pages/Home/EventsPage";
// import Recruitment from "./Pages/Registration/recruitment.jsx";
import AdminLogin from "./Pages/Admin/AdminLogin";
import AdminRoute from "./Pages/Admin/AdminRoute";
import AdminLayout from "./Pages/Admin/AdminLayout";
import AdminOverviewPage from "./Pages/Admin/AdminOverviewPage";
import AdminEventsPage from "./Pages/Admin/AdminEventsPage";
import AdminIupcPage from "./Pages/Admin/AdminIupcPage";
import AdminAlumniPage from "./Pages/Admin/AdminAlumniPage";
import AdminCommitteePage from "./Pages/Admin/AdminCommitteePage";
import AdminHallPage from "./Pages/Admin/AdminHallPage";
import AdminSecurityPage from "./Pages/Admin/AdminSecurityPage";
import AdminRecruitmentPage from "./Pages/Admin/AdminRecruitmentPage";
import AdminEmailSender from "./Pages/Admin/AdminEmailSender";
import ResumeMaker from "./Pages/Resume/ResumeMaker";
import JulyMemorialContest from "./Pages/JulyMemorialContest2026/JulyMemorialContest";
import AdminJulyContestPage from "./Pages/Admin/AdminJulyContestPage";
import ContestsListPage from "./Pages/Registration/ContestsListPage";
import ContestRegisterPage from "./Pages/Registration/ContestRegisterPage";
import AdminContestsPage from "./Pages/Admin/AdminContestsPage";
import AdminContestRegistrationsPage from "./Pages/Admin/AdminContestRegistrationsPage";
import AdminContestParticipantsPage from "./Pages/Admin/AdminContestParticipantsPage";
import Contact from "./Pages/Shared/Contact";
import QrCodeGenerator from "./Pages/Tools/QrCodeGenerator";
import NotFound from "./Pages/Shared/NotFound";

function RecruitmentClosedNotice() {
  return (
    <section className="mx-auto flex min-h-[70vh] w-full max-w-4xl items-center justify-center px-4 py-12">
      <div className="w-full rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm sm:p-10">
        <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">
          Committee Recruitment Has Ended
        </h1>
        <p className="mt-4 text-base leading-7 text-slate-700">
          Thank you for your interest in joining the GUBCPC Executive Committee.
          The current recruitment cycle is now closed, and new applications are no
          longer being accepted.
        </p>
        <p className="mt-3 text-base leading-7 text-slate-700">
          The next recruitment round will open next year. Please follow official
          GUBCPC announcements for the exact opening date and application details.
        </p>
      </div>
    </section>
  );
}

function AppLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute ? <Navbar /> : null}
      <Routes>
        <Route exact path="/" element={<Home />} />

        <Route
          exact
          path="/events"
          element={
            <>
              <EventsPage />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/hallOfShame"
          element={
            <>
              <HallOfShame />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/mentors"
          element={
            <>
              <MentorsPage />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/iupc/past"
          element={
            <>
              <PastIUPCPage />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/iupc/upcoming"
          element={
            <>
              <UpcomingIUPCPage />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/terms"
          element={
            <>
              <TermsAndConditions />
              <Footer />
            </>
          }
        />

        {/* <Route exact path="/join-committee" element={<Recruitment />} /> */}
        <Route
          exact
          path="/join-committee"
          element={
            <>
              <RecruitmentClosedNotice />
              <Footer />
            </>
          }
        />
        <Route exact path="/resume-maker" element={<ResumeMaker />} />
        <Route exact path="/recruit" element={<Navigate to="/join-committee" replace />} />
        <Route exact path="/applyForClubMember" element={<Navigate to="/join-committee" replace />} />

        <Route
          exact
          path="/committee"
          element={
            <>
              <CommitteePage />
              <Footer />
            </>
          }
        />

        <Route
          path="/events/july-memorial-programming-contest-2026"
          element={
            <>
              <JulyMemorialContest />
              <Footer />
            </>
          }
        />
        <Route
          path="/events/july-memorial-programming-contest-2026/registration"
          element={
            <>
              <JulyMemorialContest />
              <Footer />
            </>
          }
        />
        <Route
          path="/events/july-memorial-programming-contest-2026/status"
          element={
            <>
              <JulyMemorialContest />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/contact"
          element={
            <>
              <Contact />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/qr-generator"
          element={
            <>
              <QrCodeGenerator />
              <Footer />
            </>
          }
        />

        <Route
          exact
          path="/contests"
          element={
            <>
              <ContestsListPage />
              <Footer />
            </>
          }
        />
        <Route
          path="/contests/:slug"
          element={
            <>
              <ContestRegisterPage />
              <Footer />
            </>
          }
        />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<Navigate to="/admin/overview" replace />} />
          <Route path="overview" element={<AdminOverviewPage />} />
          <Route path="events" element={<AdminEventsPage />} />
          <Route path="iupc" element={<AdminIupcPage />} />
          <Route path="alumni" element={<AdminAlumniPage />} />
          <Route path="committee" element={<AdminCommitteePage />} />
          <Route path="hall" element={<AdminHallPage />} />
          <Route path="recruitment" element={<AdminRecruitmentPage />} />
          <Route path="email-sender" element={<AdminEmailSender />} />
          <Route path="july-contest" element={<AdminJulyContestPage />} />
          <Route path="contests" element={<AdminContestsPage />} />
          <Route path="contests/:contestId" element={<AdminContestRegistrationsPage />} />
          <Route path="contests/:contestId/participants" element={<AdminContestParticipantsPage />} />
          <Route path="security" element={<AdminSecurityPage />} />
          <Route path="*" element={<Navigate to="/admin/overview" replace />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
